var COEFFICIENTS, COHEN_EFFECT_SIZE_THRESHOLDS, OUTCOME_SCALE_TYPES, QS, THRESHOLDS;

QS = require('models/outcome/quality_scores');

OUTCOME_SCALE_TYPES = ['ordinal', 'ratioOrInterval'];

THRESHOLDS = [0.073, 0.18, 0.338];

COHEN_EFFECT_SIZE_THRESHOLDS = [0.2, 0.5, 0.8];

COEFFICIENTS = [0.061, 0.146, 0.271];

module.exports = {
  OUTCOME_SCALE_TYPES: OUTCOME_SCALE_TYPES,
  THRESHOLDS: THRESHOLDS,
  COEFFICIENTS: COEFFICIENTS,
  COHEN_EFFECT_SIZE_THRESHOLDS: COHEN_EFFECT_SIZE_THRESHOLDS,
  isCaseControlType: function(designStudies) {
    return designStudies === 'case_control_studies' || designStudies === 'case_control_and_other_combined' || designStudies === 'test_negative_design';
  },
  prepareDiagnosticOutcomes: function() {
    return ['TP', 'FN', 'TN', 'FP', 'Inconclusive', 'Complications'].map(function(name, idx) {
      return {
        name: name,
        largeEffect: QS.No,
        plausibleConfounding: QS.No,
        doseResponseGradient: QS.No,
        orderNumber: idx + 1
      };
    });
  },
  calculateThreshold: function(utility, thresholdIndex, denominator, higherIsBetter, outcomeType, effectMeasure) {
    var disutility;
    if (outcomeType === 'cont' && effectMeasure === 'SMD') {
      return COHEN_EFFECT_SIZE_THRESHOLDS[thresholdIndex];
    } else if (outcomeType === 'cont') {
      return;
    }
    disutility = higherIsBetter ? utility : 1 - parseFloat(utility);
    return Number(((THRESHOLDS[thresholdIndex] - (COEFFICIENTS[thresholdIndex] * disutility)) * denominator).toFixed(0));
  }
};
